enum LifeStageModeEnum {
    Date = 0,
    Age = 1,
    LifeStage = 2
}

export { LifeStageModeEnum };
